import { render, staticRenderFns } from "./Suggestion.vue?vue&type=template&id=1bc8ec9a&scoped=true"
import script from "./Suggestion.vue?vue&type=script&lang=js"
export * from "./Suggestion.vue?vue&type=script&lang=js"
import style0 from "./Suggestion.vue?vue&type=style&index=0&id=1bc8ec9a&prod&scoped=true&lang=css"
import style1 from "./Suggestion.vue?vue&type=style&index=1&id=1bc8ec9a&prod&lang=css"
import style2 from "./Suggestion.vue?vue&type=style&index=2&id=1bc8ec9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8ec9a",
  null
  
)

export default component.exports